export function renderTitle(data) {
  if (!data) return data;

  return `<div title="${data}" style="
      white-space: normal;
      width: 350px;
      line-height: 1.5em;
    ">${data}</div>`;
}
